import { render, staticRenderFns } from "./payment-details.vue?vue&type=template&id=fb992280&scoped=true&"
import script from "./payment-details.vue?vue&type=script&lang=js&"
export * from "./payment-details.vue?vue&type=script&lang=js&"
import style0 from "./payment-details.vue?vue&type=style&index=0&id=fb992280&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb992280",
  null
  
)

export default component.exports